import type { IconData } from '@stacksjs/iconify-core'

export const flipToBack: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M64 496h336v-32H64a16.02 16.02 0 0 1-16-16V120H16v328a48.055 48.055 0 0 0 48 48m400-128h32v32h-32z\"/><path fill=\"currentColor\" d=\"M173.091 368h29.091v32h-29.091zm232.727 0h29.091v32h-29.091zm-174.546 0h29.091v32h-29.091zm58.183 0h29.091v32h-29.091zm58.182 0h29.091v32h-29.091zM112 368h32v32h-32zm0-232.728h32v29.091h-32zm0-58.181h32v29.091h-32zm0 232.727h32v29.091h-32zm0-58.181h32v29.091h-32zm0-58.182h32v29.091h-32zM112 16h32v32h-32zm177.454 0h29.091v32h-29.091zm-58.182 0h29.091v32h-29.091zm174.546 0h29.091v32h-29.091zm-232.727 0h29.091v32h-29.091zm174.546 0h29.091v32h-29.091zM464 16h32v32h-32zm0 293.818h32v29.091h-32zm0-232.727h32v29.091h-32zm0 116.363h32v29.091h-32zm0-58.182h32v29.091h-32zm0 116.365h32v29.091h-32z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default flipToBack
